import { render, staticRenderFns } from "./mobile_link.vue?vue&type=template&id=30d02847&"
import script from "./mobile_link.vue?vue&type=script&lang=js&"
export * from "./mobile_link.vue?vue&type=script&lang=js&"
import style0 from "./mobile_link.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports